var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",attrs:{"id":_vm.id,"tabindex":"-1","role":"dialog"}},[_c('div',{class:[
      'modal-dialog',
      _vm.size == 'sm'
        ? 'modal-sm'
        : _vm.size == 'sm2'
        ? 'modal-sm2'
        : _vm.size == 'md'
        ? 'modal-md'
        : _vm.size == 'md2'
        ? 'modal-md2'
        : _vm.size == 'md3'
        ? 'modal-md3'
        : _vm.size == 'lg'
        ? 'modal-lg'
        : ''
    ],attrs:{"role":"document"}},[_c('div',{class:{
        'modal-content': true
      },style:({ 'margin-top': _vm.margintop ? _vm.margintop : '25%' })},[_c('div',{staticClass:"modal-header"},[_c('b',[_vm._v(_vm._s(_vm.title))]),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.localEventHandler('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{class:{
          'modal-body': true,
          'modal-body-y-scroll': _vm.showBodyYScroll
        },style:({ 'max-height': _vm.bodyMaxHeight ? _vm.bodyMaxHeight : 'auto' })},[_c('div',{staticClass:"mx-3 mt-3"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }